// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"158":"social","575":"options","597":"projects","679":"basic","710":"addons"}[chunkId] + "." + {"158":"8283f6a4","575":"d282b778","597":"a60c5c3a","679":"0c6b6697","710":"1796d84a"}[chunkId] + ".css";
};